import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import BusinessDataService from "../../services/BusinessDataService";


export default class BusinessDataForm implements FormBase {

    Name: FormFieldBase;
    CNPJ: FormFieldBase;

    constructor(Name: string, CNPJ: string) {
        this.Name = new FormFieldBase(Name, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.CNPJ = new FormFieldBase(CNPJ, [], () => "", (value: any) => { this.InputChangeCustom(value) });

        this.Name.Mandatory = false;
        this.CNPJ.Mandatory = false;
    }

    static NewInstance(): BusinessDataForm {
        return new BusinessDataForm("", "");
    }

    ValidateToGoNextStep(): string {

        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.Name.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.CNPJ.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CNPJ)];

            this.Name.Mandatory = true;
            this.CNPJ.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];
                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }

            if (existFieldImputed) {
                this.Name.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.CNPJ.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.CNPJ)];
                this.Name.Mandatory = true;
                this.CNPJ.Mandatory = true;
            } else {
                this.Name.Validations = [];
                this.CNPJ.Validations = [];
                this.Name.Error = "";
                this.CNPJ.Error = "";
                this.Name.Mandatory = false;
                this.CNPJ.Mandatory = false;
            }
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<any> {

        let propNames = Object.getOwnPropertyNames(this);

        let existFieldImputed = false;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const value = this.GetFieldByName(element).Value;

            if (value != null && value !== "" && value.toString().trim() !== "") {
                existFieldImputed = true;
            }
        }

        if (existFieldImputed) {
            const dataJson = this.getJsonObjet();
            return BusinessDataService.postInsertOrUpdateBusiness(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Name":
                return this.Name

            case "CNPJ":
                return this.CNPJ

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "profissionalId": 0,
            "nomeFantasia": this.Name.Value,
            "cnpj": this.CNPJ.Value,
        }
    }
}